import Marquee from "react-fast-marquee";

const WORDS = ["Luxury Bridal", "Editorial Elegance", "Curated Gowns", "Hand-Beaded", "By Appointment", "Perth Atelier"];

export const EditorialMarquee = () => (
  <section className="border-y border-line bg-champagne/25 py-6 md:py-8 overflow-hidden" data-testid="marquee-section">
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-3xl md:text-5xl px-8 md:px-14 text-ink/90 whitespace-nowrap">
            {w}
          </span>
          <span className="text-champagne text-2xl md:text-4xl">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
